import About from "../abouts"
import Mission from "../mission"
import Goal from "../goal"
const AboutsPage=()=>{
    return(<>
<About/>
<Mission/>
<Goal/>
    </>)
}
export default AboutsPage